import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

function Root({ children, className }: { children: ReactNode; className?: string }) {
    return <div className={cn('flex flex-col overflow-hidden', className)}>{children}</div>;
}

function Body({ children, className }: { children: ReactNode; className?: string }) {
    return <div className={cn('flex flex-col overflow-hidden', className)}>{children}</div>;
}

export const AppPageLayout = Object.assign(Root, {
    Body,
});
